import React from 'react'
import { Customer, CustomerRequestSection, CustomRequest, RequestMethods } from '@ecountabl/lib'

type Props = {
  label: string
  value?: CustomerRequestSection | null
  onChange: (section: CustomerRequestSection | null) => void
  customer?: Partial<Customer>
  isVisible?: boolean
}

const RequestSection: React.FC<Props> = ({ label, value, onChange, isVisible }: Props) => {
  const section = value || {}
  const request: CustomRequest = section.request || { requestMethod: 'GET', url: '', headers: '', body: '' }

  const setMessage = (message: string) => {
    onChange({ ...section, message })
  }

  const setRequestField = (field: keyof CustomRequest, val: string) => {
    onChange({ ...section, request: { ...request, [field]: val } })
  }

  const clearSection = () => {
    onChange(null)
  }

  return (
    <div className="form-group">
      <h4 style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
        {label}
        {typeof isVisible === 'boolean' && (
          <i
            className={`fa ${isVisible ? 'fa-eye' : 'fa-eye-slash'}`}
            title={isVisible ? 'Visible in app to users' : 'Hidden in app for users'}
            aria-label={isVisible ? 'Visible in app to users' : 'Hidden in app for users. Fill out request and message to make visible.'}
            style={{ cursor: 'help' }}
          />
        )}
      </h4>
      <label>Message</label>
      <textarea
        className="form-control"
        value={section.message || ''}
        onChange={(e) => setMessage(e.target.value)}
        style={{ width: '100%' }}
        placeholder="Text to display in UI"
      />
      <label>Request</label>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '0.5em' }}>
        <div style={{ flex: 1, flexDirection: 'column' }}>
          <label>Request Method</label>
          <select
            className="form-control"
            value={request.requestMethod}
            onChange={(e) => setRequestField('requestMethod', e.target.value as keyof typeof RequestMethods as any)}
          >
            <option value="GET">GET</option>
            <option value="POST">POST</option>
            <option value="PUT">PUT</option>
            <option value="DELETE">DELETE</option>
          </select>
        </div>
        <div style={{ flex: 1, flexDirection: 'column' }}>
          <label>URL</label>
          <input
            type="text"
            className="form-control"
            value={request.url}
            onChange={(e) => setRequestField('url', e.target.value)}
          />
        </div>
        <div style={{ flex: 1, flexDirection: 'column' }}>
          <label>Headers</label>
          <textarea
            className="form-control"
            value={request.headers || ''}
            onChange={(e) => setRequestField('headers', e.target.value)}
            style={{ width: '100%' }}
            placeholder="{}"
          />
        </div>
        <div style={{ flex: 1, flexDirection: 'column' }}>
          <label>Body</label>
          <textarea
            className="form-control"
            value={request.body || ''}
            onChange={(e) => setRequestField('body', e.target.value)}
            style={{ width: '100%' }}
            placeholder="{}"
            disabled={request.requestMethod !== 'POST' && request.requestMethod !== 'PUT'}
          />
        </div>
      </div>
      <button type="button" className="btn btn-secondary" onClick={clearSection}>
        Clear Section
      </button>
    </div>
  )
}

export default RequestSection


